import {actions as A} from '../constants/actions';

const defaultState = {
  display: false,
  message: '',
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.SHOW_LITTLE_POPUP:
      return {...state, display: true, message: payload};

    case A.HIDE_LITTLE_POPUP:
      return {...state, display: false, message: ''};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

